import { useContext, useEffect } from 'react';
import type { PopOutAudioContextValue } from '../pop-out-audio/types';
import { PopOutAudioContext } from '../pop-out-audio/pop-out-audio';
import type { VideoPlayerManagerContextValue } from '../pop-out-video/types';
import { VideoPlayerManagerContext } from '../pop-out-video/video-player-manager';
import { PlayStates, VisibilityStates } from './types';

export const PopOutMediaManager = () => {
  const {
    getCurrentlyActive: getActiveAudio,
    popOutVisibilityState: audioVisibility,
    setAllInactive: dismissAudio,
  } = useContext<PopOutAudioContextValue>(PopOutAudioContext);
  const {
    getCurrentlyActive: getActiveVideo,
    popOutVisibilityState: videoVisibility,
    dismiss: dismissVideo,
    pauseVideo,
    setNoActiveVideo,
  } = useContext<VideoPlayerManagerContextValue>(VideoPlayerManagerContext);

  const audioPlayState = getActiveAudio()?.state.playState;
  const videoPlayState = getActiveVideo().playState;

  useEffect(() => {
    if (audioPlayState === PlayStates.Playing) {
      pauseVideo();
      setNoActiveVideo();
    }
  }, [audioPlayState]);

  useEffect(() => {
    if (videoPlayState === PlayStates.Playing) {
      return dismissAudio();
    }
  }, [videoPlayState]);

  useEffect(() => {
    if (audioVisibility === VisibilityStates.Visible) {
      dismissVideo();
    }
  }, [audioVisibility]);

  useEffect(() => {
    if (videoVisibility === VisibilityStates.Visible) {
      dismissAudio();
    }
  }, [videoVisibility]);

  return null;
};
